import { serviceRecuperaFiliais, serviceRecuperaOperacoes } from './Service/service'

export const mockUnidadesAtendimento = async () => {

    const filiais = await serviceRecuperaFiliais();
    if (filiais)
        return filiais.map(t => { return { id: t.cdFilial, nome: t.nmFilial, cCusto: t.cdCCusto } })
    else
        return []
}

export function mockSociedadesUBC() {
    return ['Abramus', 'Amar', 'Assim', 'Sbacem', 'Sicam', 'Socinpro', 'Anacim', 'Abrac', 'Atida', 'Sadembra',];
}

export function mockComoConheceuUBC() {
    return [
        { id: 1, nome: 'INTERNET' },
        { id: 2, nome: 'FUNCIONÁRIO' },
        { id: 3, nome: 'EDITORA/GRAVADORA' },
        { id: 4, nome: 'EVENTO' },
        { id: 5, nome: 'OUTRO' },
    ];
}

export function mockGeneros() {
    return [
        { id: 'M', nome: 'Homem Cis' },
        { id: 'F', nome: 'Mulher Cis' },
        { id: 'T', nome: 'Homem Trans' },
        { id: 'Y', nome: 'Mulher Trans' },
        { id: 'N', nome: 'Não-binário' },
        { id: 'O', nome: 'Outro' },
        { id: 'I', nome: 'Prefiro não informar' },
    ];
}

export function mockEstadoCivil() {
    return [
        { id: 'S', nome: 'Solteiro' },
        { id: 'C', nome: 'Casado' },
        { id: 'D', nome: 'Divorciado' },
        { id: 'V', nome: 'Viúvo' },
    ];
}

export function mockParticipacoes() {
    return [
        { id: 1, nome: 'Rádio' },
        { id: 2, nome: 'Show' },
        { id: 3, nome: 'TV' },
        { id: 4, nome: 'Festivais' },
        { id: 5, nome: 'Festas e Eventos' },
        { id: 6, nome: 'Streaming' },
        { id: 7, nome: 'YouTube' },
        { id: 8, nome: 'Cinema' },
    ];
}

export function mockEstados() {
    return [
        {
            "id": "AM",
            "nome": "AMAZONAS"
        },
        {
            "id": "MA",
            "nome": "MARANHÃO"
        },
        {
            "id": "RJ",
            "nome": "RIO DE JANEIRO"
        },
        {
            "id": "SP",
            "nome": "SÃO PAULO"
        },
        {
            "id": "MG",
            "nome": "MINAS GERAIS"
        },
        {
            "id": "BA",
            "nome": "BAHIA"
        },
        {
            "id": "PE",
            "nome": "PERNAMBUCO"
        },
        {
            "id": "AL",
            "nome": "ALAGOAS"
        },
        {
            "id": "ES",
            "nome": "ESPIRITO SANTO"
        },
        {
            "id": "RS",
            "nome": "RIO GRANDE DO SUL"
        },
        {
            "id": "RN",
            "nome": "RIO GRANDE DO NORTE"
        },
        {
            "id": "MT",
            "nome": "MATO GROSSO"
        },
        {
            "id": "MS",
            "nome": "MATO GROSSO DO SUL"
        },
        {
            "id": "AC",
            "nome": "ACRE"
        },
        {
            "id": "RR",
            "nome": "RORAIMA"
        },
        {
            "id": "RO",
            "nome": "RONDONIA"
        },
        {
            "id": "SE",
            "nome": "SERGIPE"
        },
        {
            "id": "PB",
            "nome": "PARAIBA"
        },
        {
            "id": "PI",
            "nome": "PIAUI"
        },
        {
            "id": "PA",
            "nome": "PARA"
        },
        {
            "id": "TO",
            "nome": "TOCANTINS"
        },
        {
            "id": "SC",
            "nome": "SANTA CATARINA"
        },
        {
            "id": "PR",
            "nome": "PARANA"
        },
        {
            "id": "DF",
            "nome": "DISTRITO FEDERAL"
        },
        {
            "id": "GO",
            "nome": "GOIAS"
        },
        {
            "id": "AP",
            "nome": "AMAPA"
        },
        {
            "id": "CE",
            "nome": "CEARA"
        },
        {
            "id": "OE",
            "nome": "OUTROS ESTADOS"
        }
    ];
}

export function mockBancos() {
    return [
        { codigo: '332', nome: 'ACESSO SOLUÇÕES DE PAGAMENTO S.A. ' },
        { codigo: '654', nome: 'BANCO A.J. RENNER S.A.' },
        { codigo: '246', nome: 'BANCO ABC-BRASIL S.A.' },
        { codigo: '121', nome: 'BANCO AGIPLAN S.A.' },
        { codigo: '25', nome: 'BANCO ALFA S/A' },
        { codigo: '641', nome: 'BANCO ALVORADA S.A.' },
        { codigo: '213', nome: 'BANCO ARBI S.A.' },
        { codigo: '29', nome: 'BANCO BANERJ S.A.' },
        { codigo: '14', nome: 'BANCO BANESE' },
        { codigo: '719', nome: 'BANCO BANIF PRIMUS S.A.' },
        { codigo: '740', nome: 'BANCO BARCLAYS S.A.' },
        { codigo: '107', nome: 'BANCO BBM S.A.' },
        { codigo: '31', nome: 'BANCO BEG S.A.' },
        { codigo: '48', nome: 'BANCO BEMGE S.A.' },
        { codigo: '739', nome: 'BANCO BGN S.A.' },
        { codigo: '96', nome: 'BANCO BM&amp;F DE SERVICOS DE LIQUIDACAO E CUSTODIA S.A.' },
        { codigo: '318', nome: 'BANCO BMG S.A.' },
        { codigo: '116', nome: 'BANCO BNL DO BRASIL S.A.' },
        { codigo: '752', nome: 'BANCO BNP PARIBAS BRASIL S.A.' },
        { codigo: '231', nome: 'BANCO BOAVISTA INTERATLANTICO S.A.' },
        { codigo: '248', nome: 'BANCO BOAVISTA INTERATLANTICO S.A.' },
        { codigo: '218', nome: 'BANCO BONSUCESSO S.A' },
        { codigo: '262', nome: 'BANCO BOREAL S.A.' },
        { codigo: '351', nome: 'BANCO BOZANO SIMONSEN S.A.' },
        { codigo: '65', nome: 'BANCO BRACCE S.A.' },
        { codigo: '36', nome: 'BANCO BRADESCO BBI S.A.' },
        { codigo: '204', nome: 'BANCO BRADESCO CARTOES S.A.' },
        { codigo: '237', nome: 'BANCO BRADESCO S.A.' },
        { codigo: '225', nome: 'BANCO BRASCAN S.A.' },
        { codigo: '208', nome: 'BANCO BTG PACTUAL S.A.' },
        { codigo: '44', nome: 'BANCO BVA S.A.' },
        { codigo: '263', nome: 'BANCO CACIQUE S.A.' },
        { codigo: '473', nome: 'BANCO CAIXA GERAL - BRASIL S.A.' },
        { codigo: '412', nome: 'BANCO CAPITAL S.A.' },
        { codigo: '40', nome: 'BANCO CARGILL S.A.' },
        { codigo: '168', nome: 'BANCO CCF DO BRASIL S.A.' },
        { codigo: '266', nome: 'BANCO CEDULA S.A.' },
        { codigo: '2', nome: 'BANCO CENTRAL DO BRASIL S.A.' },
        { codigo: '244', nome: 'BANCO CIDADE S.A.' },
        { codigo: '233', nome: 'BANCO CIFRA S.A.' },
        { codigo: '745', nome: 'BANCO CITIBANK S.A.' },
        { codigo: '241', nome: 'BANCO CLASSICO S.A.' },
        { codigo: '215', nome: 'BANCO COMERCIAL E DE INVESTIMENTO SUDAMERIS S.A.' },
        { codigo: '753', nome: 'BANCO COMERCIAL URUGUAI S.A.' },
        { codigo: '175', nome: 'BANCO CONTINENTAL S.A.' },
        { codigo: '756', nome: 'BANCO COOPERATIVO DO BRASIL S.A.' },
        { codigo: '748', nome: 'BANCO COOPERATIVO SICREDI S.A.' },
        { codigo: '109', nome: 'BANCO CREDIBANCO S.A.' },
        { codigo: '721', nome: 'BANCO CREDIBEL S.A.' },
        { codigo: '222', nome: 'BANCO CREDIT AGRICOLE BRASIL S.A.' },
        { codigo: '505', nome: 'BANCO CREDIT SUISSE (BRASIL) S.A.' },
        { codigo: '229', nome: 'BANCO CRUZEIRO DO SUL S.A.' },
        { codigo: '3', nome: 'BANCO DA AMAZONIA SA' },
        { codigo: '733', nome: 'BANCO DAS NACOES S.A.' },
        { codigo: '707', nome: 'BANCO DAYCOVAL S.A.' },
        { codigo: '70', nome: 'BANCO DE BRASILIA S.A.' },
        { codigo: '294', nome: 'BANCO DE CRED. REAL DO R.G.S S.A.' },
        { codigo: '291', nome: 'BANCO DE CREDITO NACIONAL S.A.' },
        { codigo: '22', nome: 'BANCO DE CREDITO REAL DE MINAS GERAIS S.A.' },
        { codigo: '300', nome: 'BANCO DE LA NACION ARGENTINA S.A.' },
        { codigo: '456', nome: 'BANCO DE TOKYO-MITSUBISHI UFJ BRASIL S.A.' },
        { codigo: '487', nome: 'BANCO DEUTSCHE BANK S.A.' },
        { codigo: '214', nome: 'BANCO DIBENS S.A.' },
        { codigo: '335', nome: 'BANCO DIGIO S.A.' },
        { codigo: '1', nome: 'BANCO DO BRASIL SA' },
        { codigo: '28', nome: 'BANCO DO ESTADO DA BAHIA S.A.' },
        { codigo: '24', nome: 'BANCO DO ESTADO DE PERNAMBUCO S.A.' },
        { codigo: '27', nome: 'BANCO DO ESTADO DE SANTA CATARINA S.A.' },
        { codigo: '47', nome: 'BANCO DO ESTADO DE SERGIPE S.A.' },
        { codigo: '34', nome: 'BANCO DO ESTADO DO AMAZONAS S.A.' },
        { codigo: '35', nome: 'BANCO DO ESTADO DO CEARA S.A.' },
        { codigo: '21', nome: 'BANCO DO ESTADO DO ESPIRITO SANTO SA' },
        { codigo: '37', nome: 'BANCO DO ESTADO DO PARA S.A.' },
        { codigo: '38', nome: 'BANCO DO ESTADO DO PARANA S.A.' },
        { codigo: '39', nome: 'BANCO DO ESTADO DO PIAUI S.A.' },
        { codigo: '41', nome: 'BANCO DO ESTADO DO RIO GRANDE DO SUL S.A.' },
        { codigo: '4', nome: 'BANCO DO NORDESTE DO BRASIL S.A.' },
        { codigo: '743', nome: 'BANCO EMBLEMA S.A.' },
        { codigo: '242', nome: 'BANCO EUROINVEST S.A.' },
        { codigo: '496', nome: 'BANCO EXTERIOR DE ESPANA S.A.' },
        { codigo: '265', nome: 'BANCO FATOR S.A.' },
        { codigo: '224', nome: 'BANCO FIBRA S.A.' },
        { codigo: '200', nome: 'BANCO FICRISA AXELRUD S.A.' },
        { codigo: '626', nome: 'BANCO FICSA S.A.' },
        { codigo: '725', nome: 'BANCO FINANSINOS S.A.' },
        { codigo: '394', nome: 'BANCO FINASA BMC S.A.' },
        { codigo: '252', nome: 'BANCO FININVEST S.A.' },
        { codigo: '221', nome: 'BANCO FLEMING GRAPHUS S.A.' },
        { codigo: '346', nome: 'BANCO FRANCES E BRASILEIRO S.A.' },
        { codigo: '489', nome: 'BANCO FRANCES INTERNACIONAL-BRASIL S.A.' },
        { codigo: '734', nome: 'BANCO GERDAU S.A.' },
        { codigo: '612', nome: 'BANCO GUANABARA S.A.' },
        { codigo: '63', nome: 'BANCO IBI S.A. BANCO MULTIPLO' },
        { codigo: '228', nome: 'BANCO ICATU SA' },
        { codigo: '258', nome: 'BANCO INDUSCRED S.A.' },
        { codigo: '604', nome: 'BANCO INDUSTRIAL DO BRASIL S.A.' },
        { codigo: '320', nome: 'BANCO INDUSTRIAL E COMERCIAL S.A.' },
        { codigo: '653', nome: 'BANCO INDUSVAL S.A.' },
        { codigo: '630', nome: 'BANCO INTERCAP S.A.' },
        { codigo: '77', nome: 'BANCO INTERMEDIUM' },
        { codigo: '249', nome: 'BANCO INVESTCRED UNIBANCO S.A.' },
        { codigo: '106', nome: 'BANCO ITABANCO S.A.' },
        { codigo: '184', nome: 'BANCO ITAU BBA S.A.' },
        { codigo: '341', nome: 'BANCO ITAU S.A.' },
        { codigo: '479', nome: 'BANCO ITAUBANK S.A.' },
        { codigo: '376', nome: 'BANCO J. P. MORGAN S.A.' },
        { codigo: '42', nome: 'BANCO J. SAFRA S.A.' },
        { codigo: '74', nome: 'BANCO J. SAFRA S.A.' },
        { codigo: '79', nome: 'BANCO JBS S.A.' },
        { codigo: '217', nome: 'BANCO JONH DEERE S.A.' },
        { codigo: '757', nome: 'BANCO KEB DO BRASIL S.A.' },
        { codigo: '495', nome: 'BANCO LA PROVINCIA DE BUENOS AIRES S.A.' },
        { codigo: '494', nome: 'BANCO LA REPUBL.ORIENTAL DEL URUGUAY S.A.' },
        { codigo: '235', nome: 'BANCO LIBERAL SA.' },
        { codigo: '472', nome: 'BANCO LLOYDS BANK PLC' },
        { codigo: '600', nome: 'BANCO LUSO BRASILEIRO S.A.' },
        { codigo: '720', nome: 'BANCO MAXINVEST S.A.' },
        { codigo: '323', nome: 'BANCO MERCADO PAGO' },
        { codigo: '389', nome: 'BANCO MERCANTIL DO BRASIL S.A.' },
        { codigo: '392', nome: 'BANCO MERCANTIL-FINASA S.A.' },
        { codigo: '746', nome: 'BANCO MODAL S.A.' },
        { codigo: '738', nome: 'BANCO MORADA S.A.' },
        { codigo: '7', nome: 'BANCO NACIONAL DES. ECONOMICO S.A.' },
        { codigo: '415', nome: 'BANCO NACIONAL SA.' },
        { codigo: '735', nome: 'BANCO NEON S.A.' },
        { codigo: '45', nome: 'BANCO OPPORTUNITY S.A.' },
        { codigo: '212', nome: 'BANCO ORIGINAL S.A.' },
        { codigo: '623', nome: 'BANCO PANAMERICANO S.A.' },
        { codigo: '30', nome: 'BANCO PARAIBAN-BCO DO EST.DA PARAIBA S.A.' },
        { codigo: '254', nome: 'BANCO PARANA BANCO SA' },
        { codigo: '611', nome: 'BANCO PAULISTA S.A.' },
        { codigo: '650', nome: 'BANCO PEBB S.A' },
        { codigo: '613', nome: 'BANCO PECUNIA S.A.' },
        { codigo: '643', nome: 'BANCO PINE S.A.' },
        { codigo: '638', nome: 'BANCO PROSPER S.A.' },
        { codigo: '747', nome: 'BANCO RABOBANK INTERNATIONAL BR S.A.' },
        { codigo: '275', nome: 'BANCO REAL S.A.' },
        { codigo: '356', nome: 'BANCO REAL S.A.' },
        { codigo: '216', nome: 'BANCO REGIONAL MALCON S.A.' },
        { codigo: '633', nome: 'BANCO RENDIMENTO S.A.' },
        { codigo: '750', nome: 'BANCO REPUBLIC NATIONAL OF NEW YORK S.A.' },
        { codigo: '741', nome: 'BANCO RIBEIRAO PRETO S.A.' },
        { codigo: '72', nome: 'BANCO RURAL MAIS S.A' },
        { codigo: '453', nome: 'BANCO RURAL S.A.' },
        { codigo: '422', nome: 'BANCO SAFRA S.A.' },
        { codigo: '33', nome: 'BANCO SANTANDER (BRASIL) S.A.' },
        { codigo: '353', nome: 'BANCO SANTANDER BRASIL S.A.' },
        { codigo: '8', nome: 'BANCO SANTANDER MERIDIONAL S.A.' },
        { codigo: '424', nome: 'BANCO SANTANDER NOROESTE S.A.' },
        { codigo: '702', nome: 'BANCO SANTOS S.A.' },
        { codigo: '250', nome: 'BANCO SCHAHIN S.A.' },
        { codigo: '749', nome: 'BANCO SIMPLES S.A.' },
        { codigo: '211', nome: 'BANCO SISTEMA S.A.' },
        { codigo: '366', nome: 'BANCO SOCIETE GENERALE BRASIL S.A.' },
        { codigo: '637', nome: 'BANCO SOFISA S.A.' },
        { codigo: '12', nome: 'BANCO STANDARD DE INVESTIMENTOS S.A.' },
        { codigo: '243', nome: 'BANCO STOCK MAXIMA S.A.' },
        { codigo: '347', nome: 'BANCO SUDAMERIS BRASIL S.A.' },
        { codigo: '205', nome: 'BANCO SUL AMERICA S.A.' },
        { codigo: '464', nome: 'BANCO SUMITOMO MITSUI BRASILEIRO S.A.' },
        { codigo: '618', nome: 'BANCO TENDENCIA S.A.' },
        { codigo: '634', nome: 'BANCO TRIANGULO S.A.' },
        { codigo: '247', nome: 'BANCO UBS WARBURG S.A.' },
        { codigo: '409', nome: 'BANCO UNIBANCO S.A.' },
        { codigo: '493', nome: 'BANCO UNION BRASIL S.A.' },
        { codigo: '655', nome: 'BANCO VOTORANTIM S.A.' },
        { codigo: '610', nome: 'BANCO VR S.A.' },
        { codigo: '480', nome: 'BANCO WACHOVIA S.A.' },
        { codigo: '119', nome: 'BANCO WESTERN UNION DO BRASIL S.A.' },
        { codigo: '370', nome: 'BANCO WESTLB DO BRASIL S.A.' },
        { codigo: '348', nome: 'BANCO XP S.A.' },
        { codigo: '219', nome: 'BANCO ZOGBI S.A.' },
        { codigo: '755', nome: 'BANK OF AMERICA MERRILL LYNCH BANCO MULTIPLO S.A.' },
        { codigo: '744', nome: 'BANKBOSTON N.A.' },
        { codigo: '73', nome: 'BB BANCO POPULAR DO BRASIL S.A.' },
        { codigo: '413', nome: 'BCO BV S.A' },
        { codigo: '336', nome: 'BCO C6 S.A.' },
        { codigo: '78', nome: 'BES INVESTIMENTO DO BRASIL S.A.-BANCO DE INVESTIMENTO' },
        { codigo: '383', nome: 'BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA. ' },
        { codigo: '69', nome: 'BPN BRASIL BANCO MULTIPLO S.A' },
        { codigo: '104', nome: 'CAIXA ECONOMICA FEDERAL S.A.' },
        { codigo: '136', nome: 'CC UNICRED DO BRASIL' },
        { codigo: '477', nome: 'CITIBANK S.A.' },
        { codigo: '85', nome: 'COOPERATIVA CENTRAL DE CREDITO URBANO-CECRED' },
        { codigo: '403', nome: 'CORA SOCIEDADE DE CRÉDITO DIRETO S.A.' },
        { codigo: '97', nome: 'CREDISIS CENTRAL DE COOPERATIVAS DECRÉDITO LTDA.' },
        { codigo: '133', nome: 'CRESOL CONFEDERACAO' },
        { codigo: '210', nome: 'DRESDNER BANK LATEINAMERIKA S.A.' },
        { codigo: '364', nome: 'EFI S.A.' },
        { codigo: '64', nome: 'GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.' },
        { codigo: '62', nome: 'HIPERCARD BANCO MULTIPLO S.A.' },
        { codigo: '399', nome: 'HSBC BANK BRASIL S.A.' },
        { codigo: '492', nome: 'ING BANK N.V.' },
        { codigo: '652', nome: 'ITAU UNIBANCO HOLDING S.A.' },
        { codigo: '488', nome: 'JPMORGAN CHASE BANK' },
        { codigo: '148', nome: 'MULTI BANCO S.A.' },
        { codigo: '536', nome: 'NEON PAGAMENTOS S.A.' },
        { codigo: '151', nome: 'NOSSA CAIXA - NOSSO BANCO S.A.' },
        { codigo: '260', nome: 'NU PAGAMENTOS S.A.' },
        { codigo: '290', nome: 'PAGSEGURO INTERNET S.A.' },
        { codigo: '380', nome: 'PICPAY SERVICOS S.A.' },
        { codigo: '751', nome: 'SCOTIABANK BRASIL S.A. BANCO MÚLTIPLO' },
        { codigo: '197', nome: 'STONE PAGAMENTOS S.A' },
        { codigo: '340', nome: 'SUPERDIGITAL INSTITUIÇÃO DE PAGAMENTO S.A.' },
        { codigo: '230', nome: 'UNICARD BANCO MULTIPLO S.A.' },
        { codigo: '84', nome: 'UNIPRIME DO BRASIL - CC LTDA.' },
        { codigo: '280', nome: 'WILL FINANCEIRA S.A.CFI' },
        { codigo: '102', nome: 'XP INVESTIMENTOS CCTVM S/A' },
    ];
}

export function mockNacionalidade() {
    return [
        { id: 76, nome: 'BRASIL' },
        { id: 4, nome: 'AFEGANISTAO' },
        { id: 710, nome: 'AFRICA DO SUL' },
        { id: 8, nome: 'ALBANIA' },
        { id: 276, nome: 'ALEMANHA' },
        { id: 20, nome: 'ANDORRA' },
        { id: 24, nome: 'ANGOLA' },
        { id: 28, nome: 'ANTIGUA E BARBUDA' },
        { id: 682, nome: 'ARABIA SAUDITA' },
        { id: 32, nome: 'ARGENTINA' },
        { id: 12, nome: 'ARGERIA' },
        { id: 51, nome: 'ARMENIA' },
        { id: 533, nome: 'ARUBA' },
        { id: 36, nome: 'AUSTRALIA' },
        { id: 40, nome: 'AUSTRIA' },
        { id: 31, nome: 'AZERBAIJAO' },
        { id: 44, nome: 'BAHAMAS' },
        { id: 48, nome: 'BAHREIN' },
        { id: 50, nome: 'BANGLADESH' },
        { id: 52, nome: 'BARBADOS' },
        { id: 56, nome: 'BELGICA' },
        { id: 84, nome: 'BELIZE' },
        { id: 204, nome: 'BENIN' },
        { id: 60, nome: 'BERMUDA' },
        { id: 112, nome: 'BIELORRUSIA' },
        { id: 68, nome: 'BOLIVIA' },
        { id: 70, nome: 'BOSNIA E HERZEGOVINA' },
        { id: 72, nome: 'BOTSWANA' },
        { id: 96, nome: 'BRUNEI' },
        { id: 100, nome: 'BULGARIA' },
        { id: 854, nome: 'BURKINA FASO' },
        { id: 108, nome: 'BURUNDI' },
        { id: 64, nome: 'BUTAO' },
        { id: 132, nome: 'CABO VERDE' },
        { id: 120, nome: 'CAMAROES' },
        { id: 116, nome: 'CAMBOJA' },
        { id: 124, nome: 'CANADA' },
        { id: 634, nome: 'CATAR' },
        { id: 398, nome: 'CAZAQUISTAO' },
        { id: 148, nome: 'CHADE' },
        { id: 152, nome: 'CHILE' },
        { id: 156, nome: 'CHINA' },
        { id: 196, nome: 'CHIPRE' },
        { id: 170, nome: 'COLOMBIA' },
        { id: 174, nome: 'COMOROS' },
        { id: 178, nome: 'CONGO' },
        { id: 408, nome: 'COREIA DO NORTE' },
        { id: 410, nome: 'COREIA DO SUL' },
        { id: 384, nome: 'COSTA DO MARFIM' },
        { id: 188, nome: 'COSTA RICA' },
        { id: 191, nome: 'CROACIA' },
        { id: 192, nome: 'CUBA' },
        { id: 208, nome: 'DINAMARCA' },
        { id: 262, nome: 'DJIBOUTI' },
        { id: 212, nome: 'DOMINICA' },
        { id: 818, nome: 'EGITO' },
        { id: 222, nome: 'EL SALVADOR' },
        { id: 784, nome: 'EMIRADOS ARABES UNIDOS' },
        { id: 218, nome: 'EQUADOR' },
        { id: 232, nome: 'ERITREA' },
        { id: 703, nome: 'ESLOVAQUIA' },
        { id: 705, nome: 'ESLOVENIA' },
        { id: 724, nome: 'ESPANHA' },
        { id: 840, nome: 'ESTADOS UNIDOS' },
        { id: 233, nome: 'ESTONIA' },
        { id: 231, nome: 'ETIOPIA' },
        { id: 242, nome: 'FIJI' },
        { id: 608, nome: 'FILIPINAS' },
        { id: 246, nome: 'FINLANDIA' },
        { id: 250, nome: 'FRANCA' },
        { id: 266, nome: 'GABAO' },
        { id: 270, nome: 'GAMBIA' },
        { id: 288, nome: 'GANA' },
        { id: 268, nome: 'GEORGIA' },
        { id: 826, nome: 'GRA-BRETANHA' },
        { id: 308, nome: 'GRANADA' },
        { id: 300, nome: 'GRECIA' },
        { id: 312, nome: 'GUADALUPE' },
        { id: 320, nome: 'GUATEMALA' },
        { id: 328, nome: 'GUIANA' },
        { id: 324, nome: 'GUINE' },
        { id: 226, nome: 'GUINE EQUATORIANA' },
        { id: 624, nome: 'GUINE-BISSAU' },
        { id: 332, nome: 'HAITI' },
        { id: 528, nome: 'HOLANDA' },
        { id: 340, nome: 'HONDURAS' },
        { id: 344, nome: 'HONG KONG' },
        { id: 348, nome: 'HUNGRIA' },
        { id: 887, nome: 'IEMEN' },
        { id: 239, nome: 'ILHAS GEORGIA DO SUL E SANDWICH DO SUL' },
        { id: 584, nome: 'ILHAS MARSHALL' },
        { id: 90, nome: 'ILHAS SALOMAO' },
        { id: 796, nome: 'ILHAS TURCAS E CAICOS' },
        { id: 356, nome: 'INDIA' },
        { id: 360, nome: 'INDONESIA' },
        { id: 364, nome: 'IRAN' },
        { id: 368, nome: 'IRAQUE' },
        { id: 372, nome: 'IRLANDA' },
        { id: 352, nome: 'ISLANDIA' },
        { id: 376, nome: 'ISRAEL' },
        { id: 380, nome: 'ITALIA' },
        { id: 388, nome: 'JAMAICA' },
        { id: 392, nome: 'JAPAO' },
        { id: 400, nome: 'JORDANIA' },
        { id: 296, nome: 'KIRIBATI' },
        { id: 414, nome: 'KUWAIT' },
        { id: 418, nome: 'LAOS' },
        { id: 426, nome: 'LESOTO' },
        { id: 428, nome: 'LETONIA' },
        { id: 422, nome: 'LIBANO' },
        { id: 430, nome: 'LIBERIA' },
        { id: 434, nome: 'LIBIA' },
        { id: 438, nome: 'LIECHTENSTEIN' },
        { id: 440, nome: 'LITUANIA' },
        { id: 442, nome: 'LUXEMBURGO' },
        { id: 446, nome: 'MACAO' },
        { id: 807, nome: 'MACEDONIA' },
        { id: 450, nome: 'MADAGASCAR' },
        { id: 458, nome: 'MALASIA' },
        { id: 454, nome: 'MALAWI' },
        { id: 462, nome: 'MALDIVAS' },
        { id: 466, nome: 'MALI' },
        { id: 470, nome: 'MALTA' },
        { id: 504, nome: 'MARROCOS' },
        { id: 480, nome: 'MAURICIA' },
        { id: 478, nome: 'MAURITANIA' },
        { id: 484, nome: 'MEXICO' },
        { id: 104, nome: 'MIAMAR' },
        { id: 583, nome: 'MICRONESIA' },
        { id: 508, nome: 'MOCAMBIQUE' },
        { id: 498, nome: 'MOLDAVIA' },
        { id: 492, nome: 'MONACO' },
        { id: 496, nome: 'MONGOLIA' },
        { id: 499, nome: 'MONTENEGRO' },
        { id: 516, nome: 'NAMIBIA' },
        { id: 520, nome: 'NAURU' },
        { id: 524, nome: 'NEPAL' },
        { id: 558, nome: 'NICARAGUA' },
        { id: 562, nome: 'NIGER' },
        { id: 566, nome: 'NIGERIA' },
        { id: 578, nome: 'NORUEGA' },
        { id: 540, nome: 'NOVA CALEDONIA' },
        { id: 554, nome: 'NOVA ZELANDIA' },
        { id: 512, nome: 'OMAN' },
        { id: 585, nome: 'PALAU' },
        { id: 591, nome: 'PANAMA' },
        { id: 598, nome: 'PAPUA-NOVA GUINE' },
        { id: 586, nome: 'PAQUISTAO' },
        { id: 600, nome: 'PARAGUAI' },
        { id: 604, nome: 'PERU' },
        { id: 258, nome: 'POLINESIA FRANCESA' },
        { id: 616, nome: 'POLONIA' },
        { id: 630, nome: 'PORTO RICO' },
        { id: 620, nome: 'PORTUGAL' },
        { id: 404, nome: 'QUENIA' },
        { id: 417, nome: 'QUIRGUISTAO' },
        { id: 140, nome: 'REPUBLICA CENTRO-AFRICANA' },
        { id: 203, nome: 'REPUBLICA CHECA' },
        { id: 280, nome: 'REPUBLICA DEMOCRATICA DA ALEMANHA' },
        { id: 180, nome: 'REPUBLICA DEMOCRATICA DO CONGO' },
        { id: 214, nome: 'REPUBLICA DOMINICANA' },
        { id: 642, nome: 'ROMENIA' },
        { id: 646, nome: 'RUANDA' },
        { id: 643, nome: 'RUSSIA' },
        { id: 732, nome: 'SAARA OCIDENTAL' },
        { id: 882, nome: 'SAMOA' },
        { id: 674, nome: 'SAN MARINO' },
        { id: 662, nome: 'SANTA LUCIA' },
        { id: 659, nome: 'SAO CRISTOVAO E NEVES' },
        { id: 678, nome: 'SAO TOME E PRINCIPE' },
        { id: 670, nome: 'SAO VICENTE E GRANADINAS' },
        { id: 686, nome: 'SENEGAL' },
        { id: 694, nome: 'SERRA LEOA' },
        { id: 688, nome: 'SERVIA' },
        { id: 891, nome: 'SERVIA E MONTENEGRO' },
        { id: 690, nome: 'SEYCHELES' },
        { id: 702, nome: 'SINGAPURA' },
        { id: 760, nome: 'SIRIA' },
        { id: 706, nome: 'SOMALIA' },
        { id: 144, nome: 'SRI LANKA' },
        { id: 748, nome: 'SUAZILANDIA' },
        { id: 736, nome: 'SUDAO' },
        { id: 729, nome: 'SUDAO' },
        { id: 728, nome: 'SUDAO DO SUL' },
        { id: 752, nome: 'SUECIA' },
        { id: 756, nome: 'SUICA' },
        { id: 740, nome: 'SURINAME' },
        { id: 764, nome: 'TAILANDIA' },
        { id: 158, nome: 'TAIWAN' },
        { id: 762, nome: 'TAJIQUISTAO' },
        { id: 834, nome: 'TANZANIA' },
        { id: 626, nome: 'TIMOR-LESTE' },
        { id: 768, nome: 'TOGO' },
        { id: 776, nome: 'TONGA' },
        { id: 780, nome: 'TRINIDAD E TOBAGO' },
        { id: 788, nome: 'TUNISIA' },
        { id: 795, nome: 'TURQUEMENISTAO' },
        { id: 792, nome: 'TURQUIA' },
        { id: 798, nome: 'TUVALU' },
        { id: 804, nome: 'UCRANIA' },
        { id: 800, nome: 'UGANDA' },
        { id: 858, nome: 'URUGUAI' },
        { id: 860, nome: 'UZBEQUISTAO' },
        { id: 548, nome: 'VANUATU' },
        { id: 336, nome: 'VATICANO' },
        { id: 862, nome: 'VENEZUELA' },
        { id: 704, nome: 'VIETNAM' },
        { id: 894, nome: 'ZAMBIA' },
        { id: 716, nome: 'ZIMBABUE' },
    ];
}